import { render, staticRenderFns } from "./packageFilter.vue?vue&type=template&id=c06fa47c"
import script from "./packageFilter.vue?vue&type=script&lang=js"
export * from "./packageFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports